// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"19028819","955":"19028819"}[chunkId] + ".chunk.css";
};